export const deriveRowId = (
  row: Record<string, unknown> | undefined,
  index: number,
): string => {
  if (row && typeof row === "object") {
    const idVal = (row as { id?: unknown }).id;
    if (typeof idVal === "string" && idVal.length > 0) {
      return idVal;
    }
    const explicit = (row as { __rowId?: unknown }).__rowId;
    if (typeof explicit === "string" && explicit.length > 0) {
      return explicit;
    }
  }
  return `temp-${index}`;
};

export const deriveTempRowId = (seed: number | string): string =>
  `temp-${String(seed)}`;
